import React from 'react';
import '../../styles/components.css';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const Input: React.FC<InputProps> = ({
  label,
  error,
  helperText,
  className = '',
  id,
  ...props
}) => {
  const inputId = id || `input-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="input-wrapper">
      {label && <label htmlFor={inputId} className="glass-label">{label}</label>}
      <input
        id={inputId}
        className={`glass-input ${error ? 'glass-input-error' : ''} ${className}`}
        {...props}
      />
      {error && <span className="glass-error-text">{error}</span>}
      {helperText && !error && (
        <span className="glass-helper-text">
          {helperText}
        </span>
      )}
    </div>
  );
};

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
  helperText?: string;
}

export const TextArea: React.FC<TextAreaProps> = ({
  label,
  error,
  helperText,
  className = '',
  id,
  ...props
}) => {
  const inputId = id || `textarea-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="input-wrapper">
      {label && <label htmlFor={inputId} className="glass-label">{label}</label>}
      <textarea
        id={inputId}
        className={`glass-textarea ${error ? 'glass-input-error' : ''} ${className}`}
        {...props}
      />
      {error && <span className="glass-error-text">{error}</span>}
      {helperText && !error && (
        <span className="glass-helper-text">
          {helperText}
        </span>
      )}
    </div>
  );
};

export default Input;
